/**
 * @generated SignedSource<<1e9bd18c73aef6a6dcb21f19972ee728>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendMarketingEmailTestEmailDialogContactsQuery$variables = {
  searchTerm: string;
};
export type SendMarketingEmailTestEmailDialogContactsQuery$data = {
  readonly contacts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly emailAddress: string | null | undefined;
        readonly familyName?: string;
        readonly givenName?: string;
        readonly id: string;
        readonly teamName?: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SendMarketingEmailTestEmailDialogContactsQuery = {
  response: SendMarketingEmailTestEmailDialogContactsQuery$data;
  variables: SendMarketingEmailTestEmailDialogContactsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      }
    ],
    "concreteType": "CustomerAccountContactConnection",
    "kind": "LinkedField",
    "name": "contacts",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerAccountContactEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "teamName",
                    "storageKey": null
                  }
                ],
                "type": "TeamContact",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "givenName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "familyName",
                    "storageKey": null
                  }
                ],
                "type": "PersonContact",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendMarketingEmailTestEmailDialogContactsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendMarketingEmailTestEmailDialogContactsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1c42fd6ff804e1d7f0677197e331f7cb",
    "id": null,
    "metadata": {},
    "name": "SendMarketingEmailTestEmailDialogContactsQuery",
    "operationKind": "query",
    "text": "query SendMarketingEmailTestEmailDialogContactsQuery(\n  $searchTerm: String!\n) {\n  contacts(searchTerm: $searchTerm, first: 10) {\n    edges {\n      node {\n        __typename\n        id\n        ... on TeamContact {\n          teamName\n        }\n        ... on PersonContact {\n          givenName\n          familyName\n        }\n        emailAddress\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "11016e484f0e174afe46677577d81df3";

export default node;
